import { ListItemButton, Typography } from '@mui/material';
import { getPatients } from 'apis/admin';
import usePatient from 'store/patient/usePatient';
import useStudent from 'store/student/useStudent';
import MuiAutocomplete from 'components/MuiAutocomplete';
import { Dot } from 'styles/dot';

interface IOption {
  patient_id: string;
  name: string;
  age: string;
  nursing_record_exists?: number;
  other_record_exists?: number;
  patient_private?: boolean;
}

const CollegePatientList = ({ user_id }: { user_id: number }) => {
  const { onSelectedPatient } = usePatient();
  const { student_uuid } = useStudent();

  const optionLabel = ({ patient_id, name }: IOption) =>
    `${patient_id} ${name}`;

  const Option = ({
    patient_id,
    name,
    age,
    patient_private,
    ...props
  }: IOption) => {
    // patient_private가 true일 경우 스타일 적용
    const customStyles = patient_private
      ? { backgroundColor: '#E0E0E0', color: '#00000080' }
      : {};

    return (
      <ListItemButton {...props} sx={{ gap: 0.5, ...customStyles }}>
        <Typography variant="subtitle2" color="inherit">
          {patient_id}
        </Typography>
        <Typography variant="caption" color="inherit">
          {name}
        </Typography>
        <Typography variant="caption" color="inherit">
          {age}
        </Typography>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          {props.nursing_record_exists === 1 && <Dot $bg="#6A3A87" />}
          {props.other_record_exists === 1 && <Dot $bg="#9C57C7" />}
        </div>
      </ListItemButton>
    );
  };

  return (
    <MuiAutocomplete
      variant="standard"
      valueKey="patient_id"
      listKey="admin_patients"
      placeholder="Өвчтөн хайх"
      noOptionsText="Хайсан өвчтөн олдсонгүй. Өөр өвчтөний нэр оруулна уу"
      getOptionLabel={optionLabel}
      renderOption={(props, option) => <Option {...props} {...option} />}
      onChange={onSelectedPatient}
      getApi={request => getPatients({ user_id, ...request })}
    />
  );
};

export default CollegePatientList;
